import React, { useState, useEffect } from 'react';

import {
  makeStyles,
  Grid,
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
} from '@material-ui/core';
import InputMask from 'react-input-mask';

import styles from './styles';
import { injectIntl, FormattedMessage } from 'react-intl';
import moment from 'moment';
import DialogComponent from 'app/components/DialogComponent';
import { KeyboardDatePicker } from '@material-ui/pickers';
import helpers from 'app/utils/helpers';
import notification from 'app/config/notification';
import { fetchAllServices } from 'app/store/slices/services';
import { useDispatch, useSelector } from 'react-redux';
const useStyles = makeStyles(styles);

function Filter(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    filters,
    setFilters,
    open,
    onClose,
    sendFilter,
    hasNuSolicitacao,
    hasNuProcesso,
    hasTpServico,
    hasNuPlaca,
    hasNuLinha,
    hasNmLinha,
    hasDtPeriodoInicial,
    hasDtPeriodoFinal,
    hasNuDAE,
  } = props;

  const allServices = useSelector(state => state.services.allServices);

  useEffect(() => {
    const init = async () => {
      await dispatch(fetchAllServices());
    };
    init();
  }, [dispatch]);

  const [initialDate, setInitialDate] = useState(null);
  const [finalDate, setFinalDate] = useState(null);
  const [serviceType, setServiceType] = useState('');

  const handleChangeFilter = (key, value) => {
    const temp = { ...filters };
    temp[key] = value;
    setFilters(temp);
  };

  const handleInitialDate = date => {
    if (date === null) setInitialDate(null);
    handleChangeFilter('dtPeriodoInicial', moment.utc(date).format('YYYY-MM-DD'));
    setInitialDate(date);
  };

  const handleFinalDate = date => {
    if (date === null) setFinalDate(null);
    handleChangeFilter('dtPeriodoFinal', moment.utc(date).format('YYYY-MM-DD'));
    setFinalDate(date);
  };

  const handleServiceType = e => {
    handleChangeFilter('cdServico', e.target.value);
    setServiceType(e.target.value);
  };

  const clearFilter = async () => {
    setFilters({});
    setInitialDate(null);
    setFinalDate(null);
    setServiceType('');
    sendFilter(true);
  };

  const handleSendFilter = () => {
    let dateError = false;

    if (filters.dtPeriodoInicial && filters.dtPeriodoInicial !== '') {
      if (!helpers.validateDate(filters.dtPeriodoInicial)) {
        dateError = true;
      }
    }
    if (filters.dtPeriodoFinal && filters.dtPeriodoFinal !== '') {
      if (!helpers.validateDate(filters.dtPeriodoFinal)) {
        dateError = true;
      }
    }

    if (
      filters.dtPeriodoInicial &&
      filters.dtPeriodoInicial !== '' &&
      filters.dtPeriodoFinal &&
      filters.dtPeriodoFinal !== ''
    ) {
      let isAfter = moment.utc(filters.dtPeriodoFinal).isSameOrAfter(filters.dtPeriodoInicial);
      if (!isAfter) {
        dateError = true;
      }
    }

    if (dateError) {
      notification(
        'Favor verificar datas informadas. Elas precisam ser válidas e a data final maior ou igual a data incial.',
        {
          toastId: 'DATE_PROBLEM',
          type: 'error',
        }
      );
      return;
    }
    sendFilter();
  };

  return (
    <DialogComponent title={'Filtrar'} subtitle={''} open={open} onClose={onClose}>
      <Grid container spacing={1} className={classes.alertContainer}>
        {hasNuSolicitacao && (
          <Grid item xs={12} sm={6}>
            <InputMask
              mask={'999999/9999'}
              value={filters.nuSolicitacaoFmt ? filters.nuSolicitacaoFmt : ''}
              onChange={e => handleChangeFilter(e.target.name, e.target.value)}
            >
              {props => (
                <TextField
                  {...props}
                  name="nuSolicitacaoFmt"
                  label="Número da Solicitação"
                  margin="dense"
                  fullWidth
                  variant="filled"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // error={!!errors.deCpf}
                  // helperText={errors.deCpf ? errors.deCpf : ''}
                />
              )}
            </InputMask>
          </Grid>
        )}
        {hasNuDAE && (
          <Grid item xs={12} sm={6}>
            <InputMask
              mask={'9999/9999'}
              value={filters.nuGruFmt ? filters.nuGruFmt : ''}
              onChange={e => handleChangeFilter(e.target.name, e.target.value)}
            >
              {props => (
                <TextField
                  {...props}
                  name="nuGruFmt"
                  label="Número da DAE"
                  margin="dense"
                  fullWidth
                  variant="filled"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // error={!!errors.deCpf}
                  // helperText={errors.deCpf ? errors.deCpf : ''}
                />
              )}
            </InputMask>
          </Grid>
        )}
        {hasNuProcesso && (
          <Grid item xs={12} sm={6}>
            <TextField
              name="nuProcesso"
              label="Número do Processo"
              margin="dense"
              fullWidth
              variant="filled"
              value={filters.nuProcesso ? filters.nuProcesso : ''}
              onChange={e => handleChangeFilter(e.target.name, e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        )}
        {hasTpServico && (
          <Grid item xs={12} sm={6}>
            <FormControl variant="filled" margin="dense" fullWidth>
              <InputLabel htmlFor="tpServico" shrink={true}>
                Tipo de serviço
              </InputLabel>
              <Select
                name="tpServico"
                id="tpServico"
                value={serviceType}
                onChange={handleServiceType}
                native
              >
                <option value="">Selecione</option>
                {allServices &&
                  allServices.length > 0 &&
                  allServices.map((service, indexService) => {
                    return (
                      <option key={`service-${indexService}`} value={service.cdServico}>
                        {service.nmServico}
                      </option>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>
        )}
        {hasNuPlaca && (
          <Grid item xs={12} sm={6}>
            <TextField
              name="nuPlaca"
              label="Placa do Veículo"
              margin="dense"
              fullWidth
              variant="filled"
              value={filters.nuPlaca ? filters.nuPlaca : ''}
              onChange={e => handleChangeFilter(e.target.name, e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        )}
        {hasNuLinha && (
          <Grid item xs={12} sm={6}>
            <TextField
              name="nuLinha"
              label="Código da Linha"
              margin="dense"
              fullWidth
              variant="filled"
              value={filters.nuLinha ? filters.nuLinha : ''}
              onChange={e => handleChangeFilter(e.target.name, e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        )}
        {hasNmLinha && (
          <Grid item xs={12} sm={6}>
            <TextField
              name="nmLinha"
              label="Nome da Linha"
              margin="dense"
              fullWidth
              variant="filled"
              value={filters.nmLinha ? filters.nmLinha : ''}
              onChange={e => handleChangeFilter(e.target.name, e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        )}
        {hasDtPeriodoInicial && (
          <Grid item xs={12} sm={6}>
            <KeyboardDatePicker
              format="DD/MM/YYYY"
              margin="dense"
              fullWidth
              variant="filled"
              label="Data inicial"
              invalidLabel="Data inválida"
              invalidDateMessage="Data inválida"
              maxDateMessage="Data inválida"
              minDateMessage="Data inválida"
              autoOk
              clearable
              clearLabel={'Limpar'}
              value={initialDate}
              onChange={handleInitialDate}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              InputLabelProps={{
                shrink: true,
              }}
              className={classes.dates}
            />
          </Grid>
        )}
        {hasDtPeriodoFinal && (
          <Grid item xs={12} sm={6}>
            <KeyboardDatePicker
              format="DD/MM/YYYY"
              margin="dense"
              fullWidth
              variant="filled"
              label="Data final"
              invalidLabel="Data inválida"
              invalidDateMessage="Data inválida"
              maxDateMessage="Data inválida"
              minDateMessage="Data inválida"
              autoOk
              clearable
              clearLabel={'Limpar'}
              value={finalDate}
              onChange={handleFinalDate}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              InputLabelProps={{
                shrink: true,
              }}
              className={classes.dates}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Box className={classes.alertButtonContainer}>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              onClick={() => handleSendFilter()}
              className={classes.alertButtonCta}
            >
              <FormattedMessage id="LABELS.COMMONS.FILTER" />
            </Button>
            {Object.keys(filters).length > 0 && (
              <Button
                variant="contained"
                color="secondary"
                disableElevation
                onClick={() => clearFilter()}
                className={classes.alertButtonCta}
              >
                <FormattedMessage id="LABELS.COMMONS.CLEAR" />
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>
    </DialogComponent>
  );
}

export default injectIntl(Filter);
